/**
 * World Magnetic Model (WMM) implementation for calculating magnetic declination.
 * Based on NOAA's Geomag library.
 *
 * The WMM is updated every 5 years. This implementation uses WMM2025 coefficients
 * valid from 2025.0 to 2030.0.
 *
 * @see https://www.ncei.noaa.gov/products/world-magnetic-model
 */

// WMM2025 Coefficients (valid 2025.0 - 2030.0)
// Format: n, m, gnm, hnm, dgnm, dhnm
const WMM2025_COEFFICIENTS = `
    2025.0            WMM-2025        12/17/2024
  1  0  -29351.8       0.0       12.0        0.0
  1  1   -1410.8    4545.4       10.1      -21.9
  2  0   -2556.6       0.0        2.6        0.0
  2  1    2951.1   -3133.6      -11.6       -5.6
  2  2    1649.3    -814.5       -3.0      -22.6
  3  0    1361.0       0.0        0.2        0.0
  3  1   -2404.1     -56.6       -5.4        5.7
  3  2    1243.8     237.7       -0.1       -1.4
  3  3     453.4    -549.4       -8.4      -12.2
  4  0     895.0       0.0       -1.6        0.0
  4  1     799.5     278.6        0.2       -1.3
  4  2      42.4    -419.3       -2.9        5.4
  4  3    -131.1     251.3        2.8       -0.6
  4  4     -19.0    -298.5       -1.4        0.8
  5  0    -232.8       0.0        0.0        0.0
  5  1     354.7      43.0        0.2        0.3
  5  2     207.0     179.8        1.0        1.4
  5  3    -112.6    -123.0       -0.7        0.1
  5  4    -168.6      -5.1       -1.7        1.7
  5  5      -9.1      99.3        0.8        0.1
  6  0      62.1       0.0        0.6        0.0
  6  1      67.5     -12.5       -0.6        0.6
  6  2      72.6      68.0        0.8        0.3
  6  3    -161.0      33.3        0.3       -0.2
  6  4       2.4      -9.3        0.2       -0.5
  6  5      17.2       3.4        0.5        0.2
  6  6     -20.0      95.0        0.0        0.7
  7  0      47.8       0.0        0.0        0.0
  7  1     -96.0     -43.4        0.2        0.3
  7  2       0.2      16.9        0.3        0.1
  7  3      21.7      13.5        0.1       -0.0
  7  4      -8.0     -64.1        0.0        0.7
  7  5       1.7       5.7       -0.3        0.0
  7  6       3.7     -16.5        0.0       -0.3
  7  7       9.6       6.6       -0.1        0.0
  8  0     -20.5       0.0       -0.0        0.0
  8  1       4.0      24.6        0.0       -0.1
  8  2       1.3      -3.0       -0.1        0.1
  8  3     -13.4       0.5        0.1        0.0
  8  4       6.6       1.7        0.0        0.0
  8  5      -2.2      -7.5       -0.1        0.0
  8  6       2.9       2.6       -0.0       -0.1
  8  7      -0.1      -5.4        0.0       -0.1
  8  8       3.2       6.1        0.0        0.0
  9  0       3.6       0.0       -0.0        0.0
  9  1      -5.6      -1.3       -0.0        0.0
  9  2       0.4       0.0       -0.0        0.0
  9  3      -1.3       2.3        0.0        0.1
  9  4       0.6       3.0        0.0       -0.0
  9  5       4.7       4.5        0.0       -0.1
  9  6      -4.3      -5.8       -0.0        0.0
  9  7      -3.8      -1.5        0.0       -0.0
  9  8      -8.3       2.1        0.0        0.0
  9  9      -6.2       3.3       -0.0        0.0
 10  0      -0.2       0.0       -0.0        0.0
 10  1      -6.4       3.5        0.0       -0.0
 10  2       0.9       0.5       -0.0       -0.0
 10  3       3.7      -5.0        0.0       -0.0
 10  4      -1.0       0.0       -0.0       -0.0
 10  5       1.5      -0.4       -0.0        0.0
 10  6      -2.0       3.9       -0.0       -0.0
 10  7       3.1       0.1       -0.0       -0.0
 10  8      -2.0       2.2        0.0       -0.0
 10  9      -1.5      -0.5       -0.0       -0.0
 10 10       1.8      -1.6       -0.0       -0.0
 11  0       2.8       0.0       -0.0        0.0
 11  1      -1.7      -0.8        0.0        0.0
 11  2      -0.2       0.8       -0.0       -0.0
 11  3       0.5      -0.2        0.0       -0.0
 11  4       0.4       1.2       -0.0       -0.0
 11  5       2.0       0.4       -0.0       -0.0
 11  6      -0.2       0.4       -0.0        0.0
 11  7       0.7       1.1        0.0        0.0
 11  8       0.6      -0.3       -0.0        0.0
 11  9      -0.5       0.2        0.0       -0.0
 11 10       1.4       0.0        0.0       -0.0
 11 11      -0.7       0.6        0.0        0.0
 12  0      -0.6       0.0       -0.0        0.0
 12  1      -0.4      -0.9        0.0        0.0
 12  2       0.3       0.3        0.0       -0.0
 12  3       0.9      -0.1        0.0       -0.0
 12  4      -0.4       0.7       -0.0       -0.0
 12  5       1.0      -0.3        0.0       -0.0
 12  6       0.1       0.3       -0.0        0.0
 12  7       0.4       0.3        0.0        0.0
 12  8       0.4       0.1       -0.0        0.0
 12  9      -0.3       0.1        0.0        0.0
 12 10       0.0      -0.5        0.0        0.0
 12 11      -0.2       0.3       -0.0       -0.0
 12 12       0.3       0.2        0.0        0.0
`;

class Geomag {
    constructor(coefficients = WMM2025_COEFFICIENTS) {
        this._maxord = 12;
        this._a = 6378.137;       // WGS 1984 Equatorial axis (km)
        this._b = 6356.7523142;   // WGS 1984 Polar axis (km)
        this._re = 6371.2;
        this._a2 = this._a * this._a;
        this._b2 = this._b * this._b;
        this._c2 = this._a2 - this._b2;
        this._a4 = this._a2 * this._a2;
        this._b4 = this._b2 * this._b2;
        this._c4 = this._a4 - this._b4;

        this._epoch = null;
        this._model = null;
        this._k = null;
        this._c = null;
        this._cd = null;

        this._parseCoefficients(coefficients);
    }

    _zeros2D(dims) {
        const arr = [];
        for (let i = 0; i < dims[0]; i++) {
            arr.push(dims.length === 1 ? 0 : this._zeros2D(dims.slice(1)));
        }
        return arr;
    }

    _parseCoefficients(cof) {
        const lines = cof.trim().split(`\n`);
        const wmm = [];
        let epoch, model, modelDate;

        for (const line of lines) {
            const vals = line.trim().split(/\s+/);
            if (vals.length === 3) {
                epoch = parseFloat(vals[0]);
                model = vals[1];
                modelDate = vals[2];
            } else if (vals.length === 6) {
                wmm.push({
                    n: parseInt(vals[0], 10),
                    m: parseInt(vals[1], 10),
                    gnm: parseFloat(vals[2]),
                    hnm: parseFloat(vals[3]),
                    dgnm: parseFloat(vals[4]),
                    dhnm: parseFloat(vals[5])
                });
            }
        }

        this._epoch = epoch;
        this._model = model;
        this._unnormalize(wmm);
    }

    _unnormalize(wmmData) {
        const maxord = this._maxord;
        const c = this._zeros2D([maxord + 1, maxord + 1]);
        const cd = this._zeros2D([maxord + 1, maxord + 1]);
        const k = this._zeros2D([maxord + 1, maxord + 1]);
        const snorm = this._zeros2D([maxord + 1, maxord + 1]);

        for (const item of wmmData) {
            if (item.m <= item.n) {
                c[item.m][item.n] = item.gnm;
                cd[item.m][item.n] = item.dgnm;
                if (item.m !== 0) {
                    c[item.n][item.m - 1] = item.hnm;
                    cd[item.n][item.m - 1] = item.dhnm;
                }
            }
        }

        snorm[0][0] = 1;
        for (let n = 1; n <= maxord; n++) {
            snorm[0][n] = snorm[0][n - 1] * (2 * n - 1) / n;
            let j = 2;
            for (let m = 0, D2 = n - m + 1; D2 > 0; D2--, m++) {
                k[m][n] = ((n - 1) * (n - 1) - m * m) / ((2 * n - 1) * (2 * n - 3));
                if (m > 0) {
                    const flnmj = (n - m + 1) * j / (n + m);
                    snorm[m][n] = snorm[m - 1][n] * Math.sqrt(flnmj);
                    j = 1;
                    c[n][m - 1] = snorm[m][n] * c[n][m - 1];
                    cd[n][m - 1] = snorm[m][n] * cd[n][m - 1];
                }
                c[m][n] = snorm[m][n] * c[m][n];
                cd[m][n] = snorm[m][n] * cd[m][n];
            }
        }
        k[1][1] = 0.0;

        this._k = k;
        this._c = c;
        this._cd = cd;
    }

    /**
     * Calculate magnetic field components at a given location
     * @param {number} lat - Latitude in degrees (-90 to 90)
     * @param {number} lon - Longitude in degrees (-180 to 180)
     * @param {number} alt - Altitude in km above WGS84 ellipsoid (default 0)
     * @param {Date} date - Date for calculation (default now)
     * @returns {Object} Magnetic field components including declination (dec)
     */
    calculate(lat, lon, alt = 0, date = new Date()) {
        if (lat === undefined || lon === undefined) {
            throw new Error(`Latitude and longitude are required`);
        }

        const rad2deg = (rad) => rad * (180 / Math.PI);
        const deg2rad = (deg) => deg * (Math.PI / 180);

        const decimalDate = (d) => {
            const year = d.getFullYear();
            const isLeap = (year % 400 === 0) || (year % 4 === 0 && year % 100 !== 0);
            const daysInYear = isLeap ? 366 : 365;
            const startOfYear = new Date(year, 0, 1);
            const diff = d.valueOf() - startOfYear.valueOf();
            const daysSince = diff / (24 * 60 * 60 * 1000);
            return year + daysSince / daysInYear;
        };

        const maxord = this._maxord;
        const k = this._k;
        const c = this._c;
        const cd = this._cd;
        const a = this._a, b = this._b, re = this._re;
        const a2 = this._a2, b2 = this._b2, c2 = this._c2;
        const a4 = this._a4, b4 = this._b4, c4 = this._c4;

        const dt = decimalDate(date) - this._epoch;
        const rlat = deg2rad(lat);
        const rlon = deg2rad(lon);
        const srlon = Math.sin(rlon);
        const srlat = Math.sin(rlat);
        const crlon = Math.cos(rlon);
        const crlat = Math.cos(rlat);
        const srlat2 = srlat * srlat;
        const crlat2 = crlat * crlat;

        const fn = Array.from({ length: maxord + 2 }, (_, i) => i);
        fn.splice(1, 1);
        const fm = Array.from({ length: maxord + 1 }, (_, i) => i);
        const tc = this._zeros2D([maxord + 1, maxord + 1]);
        const sp = new Array(maxord + 1).fill(0);
        const cp = new Array(maxord + 1).fill(0);
        const pp = new Array(maxord + 1).fill(0);
        const p = this._zeros2D([maxord + 1, maxord + 1]);
        const dp = this._zeros2D([maxord + 1, maxord + 1]);

        sp[0] = 0.0;
        sp[1] = srlon;
        cp[1] = crlon;
        tc[0][0] = 0;
        cp[0] = 1.0;
        pp[0] = 1.0;
        p[0][0] = 1;

        // Convert from geodetic to spherical coords
        const q = Math.sqrt(a2 - c2 * srlat2);
        const q1 = alt * q;
        const q2 = ((q1 + a2) / (q1 + b2)) ** 2;
        const ct = srlat / Math.sqrt(q2 * crlat2 + srlat2);
        const st = Math.sqrt(1.0 - ct * ct);
        const r2 = alt * alt + 2.0 * q1 + (a4 - c4 * srlat2) / (q * q);
        const r = Math.sqrt(r2);
        const d = Math.sqrt(a2 * crlat2 + b2 * srlat2);
        const ca = (alt + d) / r;
        const sa = c2 * crlat * srlat / (r * d);

        for (let m = 2; m <= maxord; m++) {
            sp[m] = sp[1] * cp[m - 1] + cp[1] * sp[m - 1];
            cp[m] = cp[1] * cp[m - 1] - sp[1] * sp[m - 1];
        }

        let aor = re / r;
        let ar = aor * aor;
        let br = 0.0, bt = 0.0, bp = 0.0, bpp = 0.0;

        for (let n = 1; n <= maxord; n++) {
            ar = ar * aor;
            for (let m = 0, D4 = n + m + 1; D4 > 0; D4--, m++) {
                // Compute Legendre polynomials
                if (n === m) {
                    p[m][n] = st * p[m - 1][n - 1];
                    dp[m][n] = st * dp[m - 1][n - 1] + ct * p[m - 1][n - 1];
                } else if (n === 1 && m === 0) {
                    p[m][n] = ct * p[m][n - 1];
                    dp[m][n] = ct * dp[m][n - 1] - st * p[m][n - 1];
                } else if (n > 1 && n !== m) {
                    if (m > n - 2) { p[m][n - 2] = 0; }
                    if (m > n - 2) { dp[m][n - 2] = 0; }
                    p[m][n] = ct * p[m][n - 1] - k[m][n] * p[m][n - 2];
                    dp[m][n] = ct * dp[m][n - 1] - st * p[m][n - 1] - k[m][n] * dp[m][n - 2];
                }

                // Time adjust Gauss coefficients
                tc[m][n] = c[m][n] + dt * cd[m][n];
                if (m !== 0) {
                    tc[n][m - 1] = c[n][m - 1] + dt * cd[n][m - 1];
                }

                // Accumulate spherical harmonic expansions
                const par = ar * p[m][n];
                let temp1, temp2;
                if (m === 0) {
                    temp1 = tc[m][n] * cp[m];
                    temp2 = tc[m][n] * sp[m];
                } else {
                    temp1 = tc[m][n] * cp[m] + tc[n][m - 1] * sp[m];
                    temp2 = tc[m][n] * sp[m] - tc[n][m - 1] * cp[m];
                }
                bt -= ar * temp1 * dp[m][n];
                bp += fm[m] * temp2 * par;
                br += fn[n] * temp1 * par;

                // Special case: poles
                if (st === 0.0 && m === 1) {
                    if (n === 1) {
                        pp[n] = pp[n - 1];
                    } else {
                        pp[n] = ct * pp[n - 1] - k[m][n] * pp[n - 2];
                    }
                    const parp = ar * pp[n];
                    bpp += fm[m] * temp2 * parp;
                }
            }
        }

        bp = st === 0.0 ? bpp : bp / st;

        // Rotate to geodetic coordinates
        const bx = -bt * ca - br * sa;
        const by = bp;
        const bz = bt * sa - br * ca;

        // Compute declination, inclination, and intensity
        const bh = Math.sqrt(bx * bx + by * by);
        const ti = Math.sqrt(bh * bh + bz * bz);
        const dec = rad2deg(Math.atan2(by, bx));
        const dip = rad2deg(Math.atan2(bz, bh));

        // Grid variation for polar regions
        let gv = null;
        if (Math.abs(lat) >= 55.0) {
            if (lat > 0 && lon >= 0) {
                gv = dec - lon;
            } else if (lat > 0 && lon < 0) {
                gv = dec + Math.abs(lon);
            } else if (lat < 0 && lon >= 0) {
                gv = dec + lon;
            } else {
                gv = dec - Math.abs(lon);
            }
            if (gv > 180) gv -= 360;
            if (gv < -180) gv += 360;
        }

        return {
            dec,    // Magnetic Declination (degrees) - ADD this to magnetic heading for true heading
            dip,    // Magnetic Inclination (degrees)
            ti,     // Total Intensity (nT)
            bh,     // Horizontal Intensity (nT)
            bx,     // North Component (nT)
            by,     // East Component (nT)
            bz,     // Vertical Component (nT)
            lat,
            lon,
            gv      // Grid Variation (degrees) - for polar regions
        };
    }

    /**
     * Get the magnetic declination for a location
     * @param {number} lat - Latitude in degrees
     * @param {number} lon - Longitude in degrees
     * @param {number} alt - Altitude in km (default 0)
     * @param {Date} date - Date for calculation (default now)
     * @returns {number} Declination in degrees (add to magnetic heading for true heading)
     */
    getDeclination(lat, lon, alt = 0, date = new Date()) {
        return this.calculate(lat, lon, alt, date).dec;
    }

    get epoch() {
        return this._epoch;
    }
}

// Singleton instance
let _geomagInstance = null;

/**
 * Get or create the Geomag singleton instance
 * @returns {Geomag}
 */
export function getGeomag() {
    if (!_geomagInstance) {
        _geomagInstance = new Geomag();
    }
    return _geomagInstance;
}

export { Geomag };
export default Geomag;
